import { useTranslator } from '@i18n';
import { validationParams } from '@util/validations';
import { useCallback } from 'react';

export default function useLocalizeError() {
  const t = useTranslator();

  return useCallback((error: string) => t.dynamic(`validation.${error}`, validationParams, { fallback: error }), [t]);
}
